import { createSelector } from "@reduxjs/toolkit";

export const clientEvidenceState = (state) => state.clientEvidence;

export const clientEvidenceSelector = createSelector(clientEvidenceState, (state) => state);
